<template>
  <Modal :id="'cmp-contacts-groups-add_contact'" @cancelled="onCancel">
    <template slot="header"> Add Related Contact </template>
    <template slot="body">
      <div class="form-group">
        <template v-if="!showAdvanceSearch">
          <div class="search-flex">
            <InputField
              :value="contactFilterProps.name"
              :placeholder="'search'"
              :config="{
                borderStyle: 'around',
              }"
              @keyup="
                (e) => onFilterTextFieldValueChange('name', e.target.value)
              "
            ></InputField>
            <DTIconButton
              :classNames="'search--advanced'"
              :text="'Advanced Search'"
              :style="{
                minWidth: '148px',
              }"
              icon="add-blue"
              @click="onAdvancedSearchClick"
            />
          </div>
        </template>
        <template v-if="showAdvanceSearch">
          <div>
            <DTIconButton
              :classNames="'search--advanced'"
              :text="'Hide Advanced Search'"
              :style="{
                minWidth: '148px',
              }"
              icon="add-blue"
              @click="onAdvancedSearchClick"
            />
          </div>

          <TextField
            :id="'name'"
            v-bind="textFieldConfig"
            :placeholder="$t('name')"
            v-model="contactFilterProps.name"
            isModel
            @valuechanged="onFilterTextFieldValueChange"
          ></TextField>
          <TextField
            :id="'city'"
            v-bind="textFieldConfig"
            :placeholder="$t('city')"
            v-model="contactFilterProps.city"
            isModel
            @valuechanged="onFilterTextFieldValueChange"
          ></TextField>
          <Dropdown
            class="dt-dropdown"
            :options="countriesTV"
            :selected="
              countriesTV.find((c) => c.value == contactFilterProps.country)
            "
            deselect
            box
            :placeholder="$t('country')"
            v-on:selectedChange="(e) => onDropdownChange('country', e)"
            :listHeight="150"
          ></Dropdown>
          <Dropdown
            class="dt-dropdown"
            :options="groupsTV"
            :selected="
              groupsTV.find((c) => c.value == contactFilterProps.group_id1)
            "
            deselect
            box
            :placeholder="$t('groups')"
            v-on:selectedChange="(e) => onDropdownChange('group_id1', e)"
            :listHeight="150"
          ></Dropdown>
          <Dropdown
            class="dt-dropdown"
            :options="groupsTV"
            :selected="
              groupsTV.find((c) => c.value == contactFilterProps.group_id2)
            "
            deselect
            box
            :placeholder="$t('groups')"
            v-on:selectedChange="(e) => onDropdownChange('group_id2', e)"
            :listHeight="150"
          ></Dropdown>
          <div class="forward-checkbox">
            <div class="checkboxcontainer">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  @click="(e) => onFilterCheckBoxChanged('promoter', e)"
                  :name="'promoter'"
                  :id="'promoter'"
                />
                <div class="checkmark"></div>
              </div>
            </div>
            <div class="checkbox-label">
              <span style="margin-left: 10px">
                {{ $t("promoter") }}
              </span>
            </div>
          </div>
          <div class="forward-checkbox">
            <div class="checkboxcontainer">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  @click="(e) => onFilterCheckBoxChanged('venue', e)"
                  :name="'venue'"
                  :id="'venue'"
                />
                <div class="checkmark"></div>
              </div>
            </div>
            <div class="checkbox-label">
              <span style="margin-left: 10px">
                {{ $t("location") }}
              </span>
            </div>
          </div>
        </template>
      </div>
      <SearchList
        :id="'contacts'"
        :items="contacts"
        :keyProperty="'contact_id'"
        :label="'name_computed'"
        :placeholder="'Search Artists'"
        :isSearchable="false"
        @searched="loadSearchContact"
        @selected="onArtistItemClick"
        @scrollNext="onScroll"
      />
    </template>
    <template slot="options">
      <button class="dt-button s7" @click="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s7" @click="onOKClicked">
        {{ $t(`OK`) }}
      </button>
    </template>
  </Modal>
  <!-- <v-card class="dt-modal">

    <div class="dt-modal--body">
      <v-layout row wrap>
        <v-flex md6>
          <div class="form-group">
            <TextField
              :id="'name'"
              v-bind="textFieldConfig"
              :placeholder="$t('name')"
              v-model="contactFilterProps.name"
              isModel
              @valuechanged="onFilterTextFieldValueChange"
            ></TextField>
            <TextField
              :id="'city'"
              v-bind="textFieldConfig"
              :placeholder="$t('city')"
              v-model="contactFilterProps.city"
              isModel
              @valuechanged="onFilterTextFieldValueChange"
            ></TextField>
            <Dropdown
              class="dt-dropdown"
              :options="countriesTV"
              :selected="countriesTV.find(c => c.value == contactFilterProps.country)"
              box
              :placeholder="$t('country')"
              v-on:selectedChange="e => onDropdownChange('country', e)"
              :listHeight="150"
            ></Dropdown>
          </div>
        </v-flex>
        <v-flex md6>
          <div class="form-group">
            <Dropdown
              class="dt-dropdown"
              :options="groupsTV"
              :selected="groupsTV.find(c => c.value == contactFilterProps.group_id1)"
              box
              :placeholder="$t('groups')"
              v-on:selectedChange="e => onDropdownChange('group_id1', e)"
              :listHeight="150"
            ></Dropdown>
            <Dropdown
              class="dt-dropdown"
              :options="groupsTV"
              :selected="groupsTV.find(c => c.value == contactFilterProps.group_id2)"
              box
              :placeholder="$t('groups')"
              v-on:selectedChange="e => onDropdownChange('group_id2', e)"
              :listHeight="150"
            ></Dropdown>
            <div class="dt-input-box--container">
              <div class="dt-input-box minimized box input" style="height: 42px;padding-left:5px;">
                <v-layout row wrap>
                  <v-flex md2 class="text-md-right" style="padding-right:5px;">{{ $t('promoter') }}</v-flex>
                  <v-flex md2 class="checkbox-container">
                    <div class="dt-checkbox">
                      <input
                        type="checkbox"
                        @click="e => onFilterCheckBoxChanged('promoter', e)"
                        :name="'promoter'"
                        :id="'promoter'"
                      >
                      <div class="checkmark"></div>
                    </div>
                  </v-flex>
                  <v-flex md2 class="text-md-right" style="padding-right:5px;">{{ $t('location') }}</v-flex>
                  <v-flex md2 class="checkbox-container">
                    <div class="dt-checkbox">
                      <input
                        type="checkbox"
                        @click="e => onFilterCheckBoxChanged('venue', e)"
                        :name="'venue'"
                        :id="'venue'"
                      >
                      <div class="checkmark"></div>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </div>
        </v-flex>
            <SearchList
              :id="'contacts'"
              :items="contacts"
              :keyProperty="'contact_id'"
              :label="'name_computed'"
              :placeholder="'Search Artists'"
              :isSearchable="false"
              @searched="loadSearchContact"
              @selected="onArtistItemClick"
            />
        <v-layout class="contacts-container">
          <v-flex md12>
            <v-layout row align-start wrap class="contacts" pa-1>
              <v-flex
                md6
                class="contact-item"
                v-for="contact of contacts"
                :key="contact.contact_id + contact.name_computed"
              >
                <v-layout row wrap>
                  <v-flex md2 class="checkbox-container">
                    <div class="dt-checkbox">
                      <input
                        type="checkbox"
                        @click="e => onArtistCheckboxChange(e, contact)"
                        :name="'ccb' + contact.contact_id"
                        :id="'ccb' + contact.contact_id"
                        :checked="selectedContacts.has(contact.contact_id)"
                      >
                      <div class="checkmark"></div>
                    </div>
                  </v-flex>
                  <v-flex
                    md10
                    class="contact-name"
                    @click="e => onArtistItemClick(e, contact)"
                  >{{contact.name_computed}}</v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-layout>

      <v-layout row wrap>
        <v-flex md6>
          <button
            class="dt-button v1"
            @click.stop="onSelectAllClicked"
          >{{ isAllSelected ? $t('select_none') : $t('select_all') }}</button>
        </v-flex>
        <v-flex md6>
          <v-layout row wrap justify-end>
            <button class="dt-button v1" @click.stop="onOKClicked">{{$t('ok')}}</button>
            <button class="dt-button v1" @click.stop="onCancel">{{$t('cancel')}}</button>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </v-card> -->
</template>

<script>
import TextField from "@plugins/text-field/text-field";
//import Dropdown from "@plugins/dropdown/dropdown";

import { createCountriesTV } from "../../../../models/country.model";
import { addRemoveSet } from "../../../../utility";
import { ContactGroupsService } from "../../services/contact_groups.service";
import SearchList from "@dtplugins/search-list/search-list";
import Modal from "../../../../dt-plugins/modal/modal";
import { DTIconButton } from "../../../../plugins/button/button";
import InputField from "../../../../plugins/text-field/input-field";
import { ContactStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../../store/types";
export default {
  components: {
    TextField,
    //Dropdown,
    SearchList,
    Modal,
    DTIconButton,
    InputField,
  },
  props: ["modalData"],
  data: function () {
    return {
      textFieldConfig: {
        // height: 142,
        showEditIconOnHover: false,
        box: true,
      },
      contactFilterProps: {
        name: "",
        city: "",
        country: "",
        group_id1: "",
        group_id2: "",
        promoter: "0",
        venue: "0",
        group_id: "",
      },
      contacts: [],
      selectedContacts: new Set(),
      isAllSelected: false,
      showAdvanceSearch: false,
      searchString: "",
      currentRow: 100,
    };
  },
  watch: {
    contacts: {
      immediate: true,
      handler: function (newValue, oldValue) {
        this.selectedContacts = new Set([]);
      },
    },
    modalData: {
      immediate: true,
      handler: function (n, o) {
        if (n && n.contacts) {
          this.contacts = this.getComputedContacts(n.contacts);
        }

        if (n && n.group) {
          this.contactFilterProps.group_id = n.group.group_id;
        }
      },
    },
    isAllSelected: function (n, o) {
      if (n === true) {
        let allSelect = this.contacts.map((row) => row.contact_id);
        this.selectedContacts = new Set(allSelect);
      } else {
        this.selectedContacts = new Set([]);
      }
    },
  },
  computed: {
    countriesTV: function () {
      return createCountriesTV(this.modalData.countries);
    },
    groupsTV: function () {
      return this.modalData.groups
        ? this.modalData.groups.map((c) => ({
            text: c.group_name,
            value: c.group_id,
          }))
        : [];
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.GroupContactsData.SET.ALL]:
        ActionTypes.GroupContactsData.SET.ALL,
    }),
    onScroll: async function () {
      const contactArray = await ContactGroupsService.getNotContactGroupsPage(
        this.contactFilterProps.group_id,
        "unrelated_group_contacts",
        this.currentRow
      );
      this.currentRow += 100;
      //console.log("RRRRRRRR", contactArray);

      this.contacts.push(
        ...this.getComputedContacts(contactArray.data.contacts)
      );
      //console.log("SCROLL", this.currentRow, contactArray);
      //console.log("WWWWWWWWWWWWWWWWWWWWWWWWW")
    },
    onSearchInputkeyup: function () {},
    onAdvancedSearchClick: function () {
      this.showAdvanceSearch = !this.showAdvanceSearch;
    },
    onCancel: function () {
      this.$emit("cancelled");
    },
    onFilterCheckBoxChanged(name, e) {
      this.contactFilterProps[name] = e.target.checked ? "1" : "0";
      this.loadSearchContact();
    },
    onDropdownChange(name, value) {
      this.contactFilterProps[name] = value.value ? value.value : "";
      this.loadSearchContact();
    },
    onArtistCheckboxChange: function (e, contact) {
      this.selectedContacts = addRemoveSet(
        e.target.checked,
        this.selectedContacts,
        contact.contact_id
      );
    },
    onArtistItemClick: function (contactSet) {
      console.log("RRRR", contactSet);
      this.selectedContacts = contactSet;
      // this.selectedContacts = addRemoveSet(
      //   "toggle",
      //   this.selectedContacts,
      //   contact.contact_id
      // );
    },
    loadSearchContact() {
      ContactGroupsService.searchContactForAddGroupContact(
        this.contactFilterProps
      ).then((res) => {
        this.contacts = this.getComputedContacts(res.data.contacts);
      });
    },
    getComputedContacts(contacts) {
      let contactsComputed = contacts.map((row) => {
        row.name_computed = row.company_name
          ? row.company_name
          : row.first_name + " " + row.last_name;
        return row;
      });

      return contactsComputed;
    },
    onFilterTextFieldValueChange(name, value) {
      if (name == "name") {
        this.contactFilterProps.name = value;
      }
      this.loadSearchContact();
    },
    onSelectAllClicked() {
      this.isAllSelected = this.isAllSelected === true ? false : true;
    },
    onOKClicked() {
      let selectedContacts = Array.from(this.selectedContacts);
      if (selectedContacts.length) {
        ContactGroupsService.addContactsToGroup(
          this.modalData.group.group_id,
          selectedContacts
        ).then((res) => {
          this.$emit("done", res.data.contacts);
          this[ActionTypes.GroupContactsData.SET.ALL](res.data.contacts);
        });
      }
      this.onCancel();
    },
  },
};
</script>

<style lang="scss" >
.cmp-contacts-groups-add_contact {
  .search-flex {
    display: flex;
    .input-field-container {
      flex: 0.85;
    }
    .dt-button {
      flex: 0.15;
    }
  }
  .forward-checkbox {
    flex: 0.8;
    display: flex;
    flex-direction: row;
    margin-left: 5px;
    .checkboxcontainer {
      max-width: 50px;
      margin-top: 5px;
    }
  }

  .form-group .dt-dropdown {
    margin: 5px 5px !important;
  }
  .contacts-container {
    overflow: auto;
    max-height: 430px;
    .contacts {
      .contact-item {
        padding: 5px;

        .checkbox-container {
          padding: 5px 0px;
        }

        &:nth-child(4n + 1),
        &:nth-child(4n + 4) {
          background: var(--sprt-8);
        }
        .contact-name {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
